import { loadable, ZeusRouteObject } from '@bit/zeus-ssr/router'
import React from 'react'

import { AppSubLayout } from 'src/components/base/Layout/app'
import { HybridSubLayout } from 'src/components/base/Layout/hybrid'
import { WebSubLayout } from 'src/components/base/Layout/web'
import { NotFound } from 'src/components/base/NotFound'
import { loadAntdLocale } from 'src/util/locale/fetchAntdLocaleMessage'

const LoginPage = loadable(() => import('src/pages/login/index.page'))
const DashBoardPage = loadable(() => import('src/pages/dashboard/index.page'))
const FriendPage = loadable(() => import('src/pages/friend/index.page'))
const FriendInfoPage = loadable(() => import('src/pages/friend/information/index.page'))
const FriendDetailPage = loadable(() => import('src/pages/friend/detail/index.page'))
const TradePage = loadable(() => import('src/pages/trade/index.page'))
const IncomePage = loadable(() => import('src/pages/income/index.page'))
const IncomeUserDetailPage = loadable(() => import('src/pages/income/user-detail/index.page'))
const IncomeUserDetailHistoryPage = loadable(
  () => import('src/pages/income/user-detail/history/index.page')
)
const IncomeUserDetailContractPage = loadable(
  () => import('src/pages/income/dex-user-detail/contract-current/index.page')
)
const IncomeDexUserDetailPage = loadable(
  () => import('src/pages/income/dex-user-detail/index.page')
)
const IncomeDexUserDetailHistoryPage = loadable(
  () => import('src/pages/income/dex-user-detail/history/index.page')
)
const IncomeDexUserDetailContractPage = loadable(
  () => import('src/pages/income/dex-user-detail/contract-current/index.page')
)
const AcademyPage = loadable(() => import('src/pages/academy/index.page'))
const AcademyDetailPage = loadable(() => import('src/pages/academy/detail/index.page'))
const AcademyPathSuffixPage = loadable(() => import('src/pages/academy/[pathSuffix].page'))
const ActivityPage = loadable(() => import('src/pages/activity/index.page'))
const BeginnerGuidePage = loadable(() => import('src/pages/beginner-guide/index.page'))
const BrokerOverviewPage = loadable(() => import('src/pages/broker/overview/index.page'))
const BrokerDataDetailPage = loadable(() => import('src/pages/broker/data-detail/index.page'))
const BrokerSubAccountPage = loadable(() => import('src/pages/broker/sub-account/index.page'))
const ChainGoldPage = loadable(() => import('src/pages/chain-gold/index.page'))
const InviteLinkPage = loadable(() => import('src/pages/invite-link/index.page'))
const InviteLinkDetailPage = loadable(() => import('src/pages/invite-link/detail/index.page'))
const InviteLinkMaterialCenterPage = loadable(
  () => import('src/pages/invite-link/material-center/index.page')
)
const InviteLinkShortLinkDetailPage = loadable(
  () => import('src/pages/invite-link/short-link-detail/index.page')
)
const InviteLinkUpdateLinkPage = loadable(
  () => import('src/pages/invite-link/update-link/index.page')
)
const PersonalCenterPage = loadable(() => import('src/pages/personal-center/index.page'))
const SiteMessagePage = loadable(() => import('src/pages/site-message/index.page'))
const SourceCenterPage = loadable(() => import('src/pages/source-center/index.page'))
const WeeklyReportPage = loadable(() => import('src/pages/weekly-report/index.page'))

const AppDashboardPage = loadable(() => import('src/pages/app/dashboard/index.page'))
const AppFriendPage = loadable(() => import('src/pages/app/friend/index.page'))
const AppIncomePage = loadable(() => import('src/pages/app/income/index.page'))
const AppIncomeUserDetailPage = loadable(
  () => import('src/pages/app/income/user-detail/index.page')
)
const AppShareKLinePage = loadable(() => import('src/pages/app/share-kline/index.page'))
const AppShareKLineDailyDataPage = loadable(
  () => import('src/pages/app/share-kline/daily-data/index.page')
)
const AppUserManage = loadable(() => import('src/pages/app/user-manage/index.page'))

export const routerConfig: ZeusRouteObject[] = [
  {
    path: `:locales?/*`,
    i18nNS: ['common'],
    loadData: [loadAntdLocale],
    children: [
      {
        path: '',
        element: <WebSubLayout />,
        children: [
          {
            path: 'login',
            element: <LoginPage />
          },
          {
            path: 'dashboard',
            element: <DashBoardPage />
          },
          {
            path: 'friend',
            element: <FriendPage />
          },
          {
            path: 'friend/information',
            element: <FriendInfoPage />
          },
          {
            path: 'friend/detail',
            element: <FriendDetailPage />
          },
          {
            path: 'trade',
            element: <TradePage />
          },
          {
            path: 'income',
            element: <IncomePage />
          },
          {
            path: 'income/user-detail',
            element: <IncomeUserDetailPage />
          },
          {
            path: 'income/user-detail/history',
            element: <IncomeUserDetailHistoryPage />
          },
          {
            path: 'income/user-detail/contract-current',
            element: <IncomeUserDetailContractPage />
          },
          {
            path: 'income/dex-user-detail',
            element: <IncomeDexUserDetailPage />
          },
          {
            path: 'income/dex-user-detail/history',
            element: <IncomeDexUserDetailHistoryPage />
          },
          {
            path: 'income/dex-user-detail/contract-current',
            element: <IncomeDexUserDetailContractPage />
          },
          {
            path: 'academy/detail',
            element: <AcademyDetailPage />
          },
          {
            path: 'beginner-guide',
            element: <BeginnerGuidePage />
          },
          {
            path: 'broker/overview',
            element: <BrokerOverviewPage />
          },
          {
            path: 'broker/data-detail',
            element: <BrokerDataDetailPage />
          },
          {
            path: 'broker/sub-account',
            element: <BrokerSubAccountPage />
          },
          {
            path: 'chain-gold',
            element: <ChainGoldPage />
          },
          {
            path: 'invite-link',
            element: <InviteLinkPage />
          },
          {
            path: 'invite-link/detail',
            element: <InviteLinkDetailPage />
          },
          {
            path: 'invite-link/material-center',
            element: <InviteLinkMaterialCenterPage />
          },
          {
            path: 'invite-link/short-link-detail',
            element: <InviteLinkShortLinkDetailPage />
          },
          {
            path: 'invite-link/update-link',
            element: <InviteLinkUpdateLinkPage />
          },
          {
            path: 'personal-center',
            element: <PersonalCenterPage />
          }
        ]
      },
      {
        path: '',
        element: <HybridSubLayout />,
        children: [
          {
            path: 'site-message',
            element: <SiteMessagePage />
          },
          {
            path: 'academy',
            element: <AcademyPage />
          },
          {
            path: 'academy/:pathSuffix',
            element: <AcademyPathSuffixPage />
          },
          {
            path: 'activity',
            element: <ActivityPage />
          },
          {
            path: 'source-center',
            element: <SourceCenterPage />
          },
          {
            path: 'weekly-report',
            element: <WeeklyReportPage />
          }
        ]
      },
      {
        path: 'app',
        element: <AppSubLayout />,
        children: [
          {
            path: 'dashboard',
            element: <AppDashboardPage />
          },
          {
            path: 'friend',
            element: <AppFriendPage />
          },
          {
            path: 'income',
            element: <AppIncomePage />
          },
          {
            path: 'income/user-detail',
            element: <AppIncomeUserDetailPage />
          },
          {
            path: 'share-kline',
            element: <AppShareKLinePage />
          },
          {
            path: 'share-kline/daily-data',
            element: <AppShareKLineDailyDataPage />
          },
          {
            path: 'user-manage',
            element: <AppUserManage />
          }
        ]
      },
      {
        // 其他不存在页面，放在最后面
        path: '*',
        status: 404,
        element: <NotFound />
      }
    ]
  }
]
